// Generated by scripts/generate-economy-v3-contract.mjs. Do not edit.
// Sources: docs/MEGACORP_ECONOMY_V3_HTTP_API.openapi.yaml and docs/MEGACORP_ECONOMY_V3_SOLANA_IDL.json.
export const ECONOMY_V3_API_PREFIX = "/economy/v3" as const;
export const ECONOMY_V3_RULES_VERSION = "megacorp-economy-v3" as const;
export const ECONOMY_V3_RANDOMNESS_RESOLVER_VERSION = "player-points-rejection-resolver-v1" as const;
export const ECONOMY_V3_OPENAPI_SHA256 = "7155eeb3c6a097f44efcbc23687e4e72ebd54b97c9b8d7671c25c4342e367001" as const;
export const ECONOMY_V3_SOLANA_IDL_SHA256 = "1cd9e4f00f3f0fdb521b64998fdcc0840696dcfaef092b51ae5099ad58f4bf0a" as const;
export const ECONOMY_V3_RESOURCE_IDS = [
  "stone",
  "deep_slate",
  "salt",
  "quartz",
  "iron_ore",
  "copper",
  "bronze",
  "gold",
  "obsidian",
  "redstone",
  "titanium",
  "platinum",
  "diamond_ore",
  "bedrock",
  "uranium",
  "plutonium",
  "cobalt",
  "tungsten",
  "iridium",
  "voidglass"
] as const;
export const ECONOMY_V3_ASSET_IDS = [
  "fuel",
  "usdc",
  "sol",
  "player_points",
  "versus_points",
  "stone",
  "deep_slate",
  "salt",
  "quartz",
  "iron_ore",
  "copper",
  "bronze",
  "gold",
  "obsidian",
  "redstone",
  "titanium",
  "platinum",
  "diamond_ore",
  "bedrock",
  "uranium",
  "plutonium",
  "cobalt",
  "tungsten",
  "iridium",
  "voidglass"
] as const;
export const ECONOMY_V3_OPERATION_IDS = [
  "readPaidCoreState",
  "attachPaidCoreController",
  "applyPaidCoreActions",
  "readPaidCoreActionReceipt",
  "advancePaidCoreState",
  "getResourceModCatalog",
  "getResourceModInventory",
  "claimScannerPromo",
  "prepareResourceModPurchase",
  "submitResourceModPurchase",
  "recoverResourceModPurchase",
  "firePaidCubeBeam",
  "getCurrentPaidCube",
  "preparePaidCube",
  "submitPaidCube",
  "recoverPaidCube",
  "readPaidCube",
  "hitPaidCube",
  "getPlayerBootstrap",
  "getCrewRewardEstimate",
  "getCrewDashboard",
  "getSponsoredSpins",
  "redeemSponsoredSpin",
  "getEconomyConfig",
  "cancelEconomyTransactionPreparation",
  "finalizeWalletTransaction",
  "prepareEconomyTransaction",
  "prepareResourceClaimBatch",
  "prepareResourceClaimChunkBatch",
  "purchaseFuel",
  "recoverFuelPurchase",
  "getFuelPromoOffer",
  "claimFuelPromo",
  "redeemFuel",
  "recoverFuelRedemption",
  "startCubeRun",
  "getPlayerActivitySnapshot",
  "getCurrentCubeRun",
  "resumeCubeRun",
  "recordCubeHitBatch",
  "completeCubeRun",
  "recoverCubeRun",
  "getCurrentWeeklyPlayerPointsState",
  "getWeeklyPlayerPointsState",
  "getWeeklyPlayerPointsLeaderboard",
  "finalizeWeeklySettlement",
  "claimWeeklyUsdc",
  "recoverWeeklyUsdcClaim",
  "createRefineryAttempt",
  "settleRefineryAttempt",
  "recoverRefineryAttempt",
  "claimResourceChunk",
  "recoverResourceClaimChunk",
  "claimProcessedResource",
  "listProcessedResourceClaims",
  "recoverProcessedResourceClaim",
  "quoteScannerUpgrade",
  "equipScanner",
  "redeemOperatorLicenseScanner",
  "claimSeekerGenesisScanner",
  "purchaseScannerUpgrade",
  "recoverScannerUpgrade",
  "quoteCannonPurchase",
  "purchaseCannon",
  "recoverCannonPurchase",
  "burnResourceForVersusPoints",
  "prepareVersusPointsBurnAttestation",
  "recoverVersusPointsContribution",
  "getCrewVersusPointsDay",
  "getCrewVersusPointsDayMemberContributions",
  "getDailyVersusPointsLeaderboard",
  "getWeeklyVersusPointsLeaderboard",
  "getResourceFuelMarkets",
  "getResourceFuelMarketCandles",
  "getResourceFuelMarketTrades",
  "quoteResourceFuelSwap",
  "executeResourceFuelSwap",
  "recoverResourceFuelSwap",
  "getMyOperatorProfile",
  "getMyEconomyState",
  "updateMyOperatorProfile",
  "listCrews",
  "createCrew",
  "getCrew",
  "requestCrewMembership",
  "decideCrewMembershipRequest",
  "inviteCrewMember",
  "acceptCrewInvitation",
  "cancelCrewMembershipAction",
  "removeCrewMember",
  "leaveCrew",
  "transferCrewCaptaincy",
  "archiveCrew",
  "getCrewRoster",
  "getCrewChatSnapshot",
  "getCrewChat",
  "postCrewChatMessage",
  "deleteCrewChatMessage",
  "reactToCrewChatMessage",
  "updateCrewChatRetention",
  "createCrewChatSocketTicket",
  "createEconomyActivitySocketTicket",
  "getBeamInventory",
  "fireCubeBeam",
  "quoteAutomationContract",
  "purchaseAutomationContract",
  "getCurrentAutomationContract",
  "recoverAutomationContract",
  "pauseAutomationContract",
  "setMiningRunMode",
  "setAutomaticCannons",
  "createUnboundCrewLogoUpload",
  "createCrewLogoUpload",
  "getCrewLogoUploadStatus",
  "replaceCrewLogo",
  "clearCrewLogo",
  "getCurrentCompetitionSeason",
  "getRewardHistory",
  "getRewardHistoryDetail",
  "listRewardClaims",
  "getRewardClaim",
  "prepareRewardClaim",
  "getCorporateLedger",
  "quoteRefineryAttempt",
  "getOperatorJourneySnapshot",
  "getOperatorJourney",
  "advanceOperatorJourney",
  "quoteGuidedRefinery",
  "getCurrentExpeditionSpeedup",
  "getCurrentExpedition",
  "prepareExpedition",
  "submitExpedition",
  "recoverExpedition",
  "readExpedition",
  "claimExpedition",
  "prepareExpeditionSpeedup",
  "submitExpeditionSpeedup",
  "recoverExpeditionSpeedup"
] as const;
export const ECONOMY_V3_HTTP_ROUTES = [
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/core/read",
    "operationId": "readPaidCoreState",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/core/attach",
    "operationId": "attachPaidCoreController",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/core/actions",
    "operationId": "applyPaidCoreActions",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/core/receipt",
    "operationId": "readPaidCoreActionReceipt",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/core/advance",
    "operationId": "advancePaidCoreState",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/catalog",
    "operationId": "getResourceModCatalog",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/inventory",
    "operationId": "getResourceModInventory",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/promos/claim",
    "operationId": "claimScannerPromo",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/prepare",
    "operationId": "prepareResourceModPurchase",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/submit",
    "operationId": "submitResourceModPurchase",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resource-mods/recover",
    "operationId": "recoverResourceModPurchase",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/beam",
    "operationId": "firePaidCubeBeam",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/current",
    "operationId": "getCurrentPaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/prepare",
    "operationId": "preparePaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/submit",
    "operationId": "submitPaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/recover",
    "operationId": "recoverPaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/read",
    "operationId": "readPaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/paid-cubes/hits",
    "operationId": "hitPaidCube",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/player/bootstrap",
    "operationId": "getPlayerBootstrap",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/reward-estimate",
    "operationId": "getCrewRewardEstimate",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/dashboard",
    "operationId": "getCrewDashboard",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/sponsored-spins",
    "operationId": "getSponsoredSpins",
    "area": "SPONSORED_SPINS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/sponsored-spins/{campaignId}/spin",
    "operationId": "redeemSponsoredSpin",
    "area": "SPONSORED_SPINS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/config",
    "operationId": "getEconomyConfig",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/transactions/cancel-preparation",
    "operationId": "cancelEconomyTransactionPreparation",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/transactions/finalize",
    "operationId": "finalizeWalletTransaction",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/transactions/prepare",
    "operationId": "prepareEconomyTransaction",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/transactions/prepare-resource-claims",
    "operationId": "prepareResourceClaimBatch",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/transactions/prepare-resource-claim-chunks",
    "operationId": "prepareResourceClaimChunkBatch",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/purchases",
    "operationId": "purchaseFuel",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/purchases/{receiptId}",
    "operationId": "recoverFuelPurchase",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/promos/offer",
    "operationId": "getFuelPromoOffer",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/promos/claim",
    "operationId": "claimFuelPromo",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/redemptions",
    "operationId": "redeemFuel",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/fuel/redemptions/{receiptId}",
    "operationId": "recoverFuelRedemption",
    "area": "FUEL",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs",
    "operationId": "startCubeRun",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/activity/snapshot",
    "operationId": "getPlayerActivitySnapshot",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs/current",
    "operationId": "getCurrentCubeRun",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs/{cubeRunId}",
    "operationId": "resumeCubeRun",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs/{cubeRunId}/hit-batches",
    "operationId": "recordCubeHitBatch",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs/{cubeRunId}/completion",
    "operationId": "completeCubeRun",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/cube-runs/{cubeRunId}/recovery",
    "operationId": "recoverCubeRun",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/weeks/current",
    "operationId": "getCurrentWeeklyPlayerPointsState",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/weeks/{weekId}",
    "operationId": "getWeeklyPlayerPointsState",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/leaderboards/player-points/weekly",
    "operationId": "getWeeklyPlayerPointsLeaderboard",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/weeks/{weekId}/settlements",
    "operationId": "finalizeWeeklySettlement",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": "WEEKLY_SETTLEMENT_AUTHORITY",
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/weeks/{weekId}/claims",
    "operationId": "claimWeeklyUsdc",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/weeks/{weekId}/claims/{claimId}/recovery",
    "operationId": "recoverWeeklyUsdcClaim",
    "area": "WEEKLY_PLAYER_POINTS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/refinery/attempts",
    "operationId": "createRefineryAttempt",
    "area": "REFINERY",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/refinery/attempts/{attemptId}/settlement",
    "operationId": "settleRefineryAttempt",
    "area": "REFINERY",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": "REFINERY_AUTHORITY"
  },
  {
    "method": "POST",
    "path": "/economy/v3/refinery/attempts/{attemptId}/recovery",
    "operationId": "recoverRefineryAttempt",
    "area": "REFINERY",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/claim-chunks",
    "operationId": "claimResourceChunk",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/claim-chunks/{chunkId}",
    "operationId": "recoverResourceClaimChunk",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/claims",
    "operationId": "claimProcessedResource",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/claims/list",
    "operationId": "listProcessedResourceClaims",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/claims/{claimId}",
    "operationId": "recoverProcessedResourceClaim",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/quotes",
    "operationId": "quoteScannerUpgrade",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/equip",
    "operationId": "equipScanner",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/rewards",
    "operationId": "redeemOperatorLicenseScanner",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/seeker-genesis",
    "operationId": "claimSeekerGenesisScanner",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/purchases",
    "operationId": "purchaseScannerUpgrade",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/scanners/purchases/{receiptId}/recovery",
    "operationId": "recoverScannerUpgrade",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/cannons/quotes",
    "operationId": "quoteCannonPurchase",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/cannons/purchases",
    "operationId": "purchaseCannon",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/progression/cannons/purchases/{receiptId}/recovery",
    "operationId": "recoverCannonPurchase",
    "area": "PROGRESSION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/burns/versus-points",
    "operationId": "burnResourceForVersusPoints",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/burns/versus-points/attestations",
    "operationId": "prepareVersusPointsBurnAttestation",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/resources/burns/versus-points/{receiptId}",
    "operationId": "recoverVersusPointsContribution",
    "area": "RESOURCES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/days/{dayId}",
    "operationId": "getCrewVersusPointsDay",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/days/{dayId}/members",
    "operationId": "getCrewVersusPointsDayMemberContributions",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/leaderboards/versus-points/daily",
    "operationId": "getDailyVersusPointsLeaderboard",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/leaderboards/versus-points/weekly",
    "operationId": "getWeeklyVersusPointsLeaderboard",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets",
    "operationId": "getResourceFuelMarkets",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets/{resourceId}/candles",
    "operationId": "getResourceFuelMarketCandles",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets/{resourceId}/trades",
    "operationId": "getResourceFuelMarketTrades",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets/quotes",
    "operationId": "quoteResourceFuelSwap",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets/swaps",
    "operationId": "executeResourceFuelSwap",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/markets/swaps/{swapId}",
    "operationId": "recoverResourceFuelSwap",
    "area": "MARKETS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/me/profile",
    "operationId": "getMyOperatorProfile",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/me/state",
    "operationId": "getMyEconomyState",
    "area": "CONFIGURATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/me/profile/update",
    "operationId": "updateMyOperatorProfile",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/query",
    "operationId": "listCrews",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews",
    "operationId": "createCrew",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}",
    "operationId": "getCrew",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/join-requests",
    "operationId": "requestCrewMembership",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/join-requests/{requestId}/decision",
    "operationId": "decideCrewMembershipRequest",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/invitations",
    "operationId": "inviteCrewMember",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/invitations/{requestId}/accept",
    "operationId": "acceptCrewInvitation",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/membership-actions/{requestId}/cancel",
    "operationId": "cancelCrewMembershipAction",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/members/{wallet}/remove",
    "operationId": "removeCrewMember",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/leave",
    "operationId": "leaveCrew",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/captain-transfer",
    "operationId": "transferCrewCaptaincy",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/archive",
    "operationId": "archiveCrew",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/roster",
    "operationId": "getCrewRoster",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/snapshot",
    "operationId": "getCrewChatSnapshot",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat",
    "operationId": "getCrewChat",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/messages",
    "operationId": "postCrewChatMessage",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/messages/{messageId}/delete",
    "operationId": "deleteCrewChatMessage",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/messages/{messageId}/reaction",
    "operationId": "reactToCrewChatMessage",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/retention",
    "operationId": "updateCrewChatRetention",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/chat/socket-ticket",
    "operationId": "createCrewChatSocketTicket",
    "area": "PRESERVED_CREWS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/activity/socket-ticket",
    "operationId": "createEconomyActivitySocketTicket",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/beams/inventory",
    "operationId": "getBeamInventory",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/beams/activations",
    "operationId": "fireCubeBeam",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/quotes",
    "operationId": "quoteAutomationContract",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts",
    "operationId": "purchaseAutomationContract",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": true,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts/current",
    "operationId": "getCurrentAutomationContract",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts/{contractId}/recovery",
    "operationId": "recoverAutomationContract",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts/{contractId}/pause",
    "operationId": "pauseAutomationContract",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts/{contractId}/mode",
    "operationId": "setMiningRunMode",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/automation/contracts/{contractId}/automatic-cannons",
    "operationId": "setAutomaticCannons",
    "area": "AUTOMATION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crew-logo-uploads",
    "operationId": "createUnboundCrewLogoUpload",
    "area": "CREW_LOGOS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/logo/uploads",
    "operationId": "createCrewLogoUpload",
    "area": "CREW_LOGOS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/logo/uploads/{uploadId}",
    "operationId": "getCrewLogoUploadStatus",
    "area": "CREW_LOGOS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/logo/replacement",
    "operationId": "replaceCrewLogo",
    "area": "CREW_LOGOS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/crews/{crewId}/logo/clear",
    "operationId": "clearCrewLogo",
    "area": "CREW_LOGOS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/competition/current",
    "operationId": "getCurrentCompetitionSeason",
    "area": "VERSUS_POINTS_COMPETITION",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/rewards/history",
    "operationId": "getRewardHistory",
    "area": "REWARD_CLAIMS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/rewards/history/detail",
    "operationId": "getRewardHistoryDetail",
    "area": "REWARD_CLAIMS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/rewards/claims",
    "operationId": "listRewardClaims",
    "area": "REWARD_CLAIMS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/rewards/claims/{claimId}",
    "operationId": "getRewardClaim",
    "area": "REWARD_CLAIMS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/rewards/claims/{claimId}/prepare",
    "operationId": "prepareRewardClaim",
    "area": "REWARD_CLAIMS",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [
      "RECONCILIATION_REQUIRED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/corporate/ledger",
    "operationId": "getCorporateLedger",
    "area": "CORPORATE",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/refinery/quotes",
    "operationId": "quoteRefineryAttempt",
    "area": "REFINERY",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/operator/journey/snapshot",
    "operationId": "getOperatorJourneySnapshot",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/operator/journey",
    "operationId": "getOperatorJourney",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/operator/journey/advance",
    "operationId": "advanceOperatorJourney",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/operator/journey/refinery/quote",
    "operationId": "quoteGuidedRefinery",
    "area": "PRESERVED_PLAYER",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/speedup/current",
    "operationId": "getCurrentExpeditionSpeedup",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/current",
    "operationId": "getCurrentExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/prepare",
    "operationId": "prepareExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/submit",
    "operationId": "submitExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/recover",
    "operationId": "recoverExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/read",
    "operationId": "readExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": true,
    "financialMutation": false,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": false,
    "recoverableStates": [],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/claim",
    "operationId": "claimExpedition",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/speedup/prepare",
    "operationId": "prepareExpeditionSpeedup",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/speedup/submit",
    "operationId": "submitExpeditionSpeedup",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  },
  {
    "method": "POST",
    "path": "/economy/v3/expeditions/speedup/recover",
    "operationId": "recoverExpeditionSpeedup",
    "area": "CUBES",
    "walletOwnership": true,
    "signedIntent": true,
    "idempotent": true,
    "readOnly": false,
    "financialMutation": true,
    "finalizedSolanaEvidence": false,
    "confirmedSolanaEvidence": true,
    "recoverableStates": [
      "PENDING",
      "FAILED"
    ],
    "requiredRole": null,
    "serverExecutionRole": null
  }
] as const;
export const ECONOMY_V3_SOLANA_PROGRAM_NAME = "megacorp_economy" as const;
export const ECONOMY_V3_SOLANA_PROGRAM_ADDRESS = "zfgfBLnys5BVErNGkwYmhVVhXUPasJgwJzJg7Me7xrW" as const;
export const ECONOMY_V3_SOLANA_INSTRUCTION_NAMES = [
  "activate_commitment_mining_controller",
  "activate_progression_split",
  "burn_resource_for_versus_points",
  "claim_generic_asset",
  "claim_processed_resource",
  "claim_promo_fuel",
  "claim_weekly_usdc",
  "close_retarget_idempotency_receipt",
  "commit_player_points_randomness",
  "complete_cube_run",
  "complete_cube_run_with_server_points",
  "configure_funded_sessions",
  "deliver_weekly_usdc",
  "extend_funded_allocation",
  "finalize_weekly_settlement",
  "finish_automation_contract",
  "harvest_fuel_transfer_fees",
  "initialize_economy",
  "initialize_payment_reserves",
  "initialize_resource_emission",
  "initialize_weekly_epoch",
  "migrate_legacy_player_points",
  "pay_cube_admission",
  "pay_sponsored_spin_prize",
  "purchase_automation_contract",
  "purchase_cannon",
  "purchase_cannon_charges",
  "purchase_cube_mod",
  "purchase_expedition_speedup",
  "purchase_fuel",
  "record_and_claim_resource",
  "record_resource_claim",
  "redeem_fuel",
  "redirect_fuel_growth_to_buyback",
  "register_assets",
  "request_funded_session_close",
  "reserve_funded_session",
  "retarget_resource_difficulty",
  "return_funded_reservation",
  "seal_funded_session_close",
  "seal_weekly_player_points",
  "set_pause",
  "settle_funded_cube_entry",
  "settle_player_points_outcome",
  "settle_sol_payment",
  "settle_usdc_payment",
  "sponsor_player_pool",
  "start_cube_run",
  "upgrade_scanner",
  "upgrade_scanner_with_skip"
] as const;
export const ECONOMY_V3_SOLANA_ACCOUNT_NAMES = [
  "AssetRegistry",
  "AutomationContract",
  "CannonLicense",
  "CrewContributionReceipt",
  "CrewDayTotals",
  "CrewMemberDayTotals",
  "CrewWeekTotals",
  "CubeModReceipt",
  "CubeRun",
  "EconomyConfig",
  "ExpeditionSpeedupReceipt",
  "FuelBackingReceipt",
  "FundedSession",
  "FundedSessionPolicy",
  "GenericAssetClaimReceipt",
  "IdempotencyReceipt",
  "LegacyPlayerPointsMigrationReceipt",
  "OperatorGameplayState",
  "PaidAdmissionReceipt",
  "PaymentReserves",
  "PaymentSettlement",
  "PaymentWeek",
  "PlayerPointsOutcomeReceipt",
  "PlayerPoolSponsorship",
  "ProgressionPaymentReceipt",
  "ResourceClaim",
  "ResourceEmissionState",
  "ScannerLicense",
  "ServerPlayerPointsReceipt",
  "SponsoredSpinPayoutReceipt",
  "UsdcClaim",
  "WeeklyEpoch",
  "WeeklyPlayerPointsPosition",
  "WeeklyPlayerPointsSeal",
  "WeeklySettlement"
] as const;
export const ECONOMY_V3_SOLANA_TYPE_NAMES = [
  "AssetRegistry",
  "AutomationContract",
  "CannonLicense",
  "CrewContributionReceipt",
  "CrewDayTotals",
  "CrewMemberDayTotals",
  "CrewWeekTotals",
  "CubeModReceipt",
  "CubeRun",
  "CubeRunStatus",
  "EconomyConfig",
  "ExpeditionSpeedupReceipt",
  "FuelBackingReceipt",
  "FuelGrowthRedirected",
  "FundedSession",
  "FundedSessionPolicy",
  "GenericAssetClaimReceipt",
  "IdempotencyReceipt",
  "InitializeEconomyAuthorities",
  "LegacyPlayerPointsMigrationReceipt",
  "MutationStatus",
  "OperatorGameplayState",
  "PaidAdmissionReceipt",
  "PauseScope",
  "PaymentReserves",
  "PaymentSettlement",
  "PaymentWeek",
  "PlayerPointsOutcomeReceipt",
  "PlayerPoolSponsorship",
  "ProgressionPaymentReceipt",
  "RegisteredResource",
  "ResourceClaim",
  "ResourceEmissionState",
  "ScannerLicense",
  "ServerPlayerPointsReceipt",
  "SponsoredSpinPayoutReceipt",
  "UsdcClaim",
  "WeeklyEpoch",
  "WeeklyEpochStatus",
  "WeeklyPlayerPointsPosition",
  "WeeklyPlayerPointsSeal",
  "WeeklySettlement",
  "AssetId",
  "CrewLogoStatus",
  "CrewLogo"
] as const;
export type EconomyV3ResourceId = typeof ECONOMY_V3_RESOURCE_IDS[number];
export type EconomyV3AssetId = typeof ECONOMY_V3_ASSET_IDS[number];
export type EconomyV3OperationId = typeof ECONOMY_V3_OPERATION_IDS[number];
export type EconomyV3HttpRoute = typeof ECONOMY_V3_HTTP_ROUTES[number];
